export default __webpack_public_path__ + "static/media/Imagery.651f1e93.png";